import { Routes, Route } from 'react-router-dom'
import { OptionalAuthRoute } from '../components/auth/OptionalAuthRoute'
import { ROUTES } from '../constants/routes'

// Pages
import { Index } from '../pages/Index'
import { Login } from '../pages/auth/Login'
import { Register } from '../pages/auth/Register'
import { AuthCallback } from '../components/auth/AuthCallback'
import { PrivacyPolicy } from '../pages/PrivacyPolicy'
import { TermsOfService } from '../pages/TermsOfService'
import { About } from '../pages/About'
import { Help } from '../pages/Help'
import { Settings } from '../pages/Settings'
import { Contact } from '../pages/Contact'
import { ConversationResume } from '../pages/ConversationResume'
import NotFound from '../pages/NotFound'

export const AppRoutes = () => (
  <Routes>
    {/* Public Routes */}
    <Route path={ROUTES.LOGIN} element={<Login />} />
    <Route path={ROUTES.REGISTER} element={<Register />} />
    <Route path={ROUTES.AUTH_CALLBACK} element={<AuthCallback />} />
    <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPolicy />} />
    <Route path={ROUTES.TERMS_OF_SERVICE} element={<TermsOfService />} />
    <Route path={ROUTES.ABOUT} element={<About />} />
    <Route path={ROUTES.HELP} element={<Help />} />
    <Route path={ROUTES.CONTACT} element={<Contact />} />

    {/* Optional Auth Routes */}
    <Route
      path={ROUTES.HOME}
      element={
        <OptionalAuthRoute>
          <Index />
        </OptionalAuthRoute>
      }
    />
    <Route
      path={ROUTES.SETTINGS}
      element={
        <OptionalAuthRoute>
          <Settings />
        </OptionalAuthRoute>
      }
    />
    <Route
      path="/conversation/:id"
      element={
        <OptionalAuthRoute>
          <ConversationResume />
        </OptionalAuthRoute>
      }
    />

    {/* 404 - Catch all route */}
    <Route path="*" element={<NotFound />} />
  </Routes>
)
